var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.524 5.963a7 7 0 0 0-9.352 2.136l1.752-.457a1 1 0 1 1 .504 1.935l-4.105 1.07a1 1 0 0 1-1.22-.714l-1.07-4.106a1 1 0 1 1 1.935-.504l.464 1.781A9 9 0 1 1 3.34 14.51a1 1 0 1 1 1.92-.556 7 7 0 1 0 10.263-7.99Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7a1 1 0 0 1 1 1v3.586l2.207 2.207a1 1 0 0 1-1.414 1.414l-2.5-2.5-.004-.004A.997.997 0 0 1 11 12V8a1 1 0 0 1 1-1Z",
  fill: "currentColor"
})));
export default SvgHistory;